import React, { useEffect, useState } from "react";
import { Box, Grid, Checkbox, TextField, Typography } from "@mui/material";
import RequiredLabel from "../../shared/RequiredLabel";

const OperationExperience = ({
  value,
  onChange,
  isRequired = false,
  endpoint = "/operation_autocomplete",
}) => {
  const [operationOptions, setOperationOptions] = useState([]);

  useEffect(() => {
    fetch(endpoint)
      .then((res) => res.json())
      .then((data) => setOperationOptions(data))
      .catch((err) => console.error("工程一覧取得エラー:", err));
  }, [endpoint]);

  // チェック状態変更
  const handleCheck = (id) => {
    const exists = value.find((op) => op.operation_id === id);
    if (exists) {
      // チェックを外す → 除去
      onChange(value.filter((op) => op.operation_id !== id));
    } else {
      // チェックを入れる → 追加
      onChange([...value, { operation_id: id, experience_year: "" }]);
    }
  };

  // 年数変更
  const handleYearChange = (id, newVal) => {
    const updated = value.map((op) =>
      op.operation_id === id ? { ...op, experience_year: newVal } : op
    );
    onChange(updated);
  };

  return (
    <Box>
      {/* 見出し */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
        <Typography sx={{ fontSize: 14 }}>工程</Typography>
        <RequiredLabel show={isRequired} />
      </Box>

      {operationOptions.map(({ id, name }) => {
        const checkedOp = value.find((op) => op.operation_id === id);
        const isChecked = !!checkedOp;

        return (
          <Grid
            container
            spacing={2}
            key={id}
            alignItems="center"
            sx={{ mb: 1.5, opacity: isChecked ? 1 : 0.5 }}
          >
            <Grid item xs={4} sm={3}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Checkbox
                  checked={isChecked}
                  onChange={() => handleCheck(id)}
                  color="primary"
                />
                <Typography sx={{ fontSize: 16 }}>{name}</Typography>
              </Box>
            </Grid>

            <Grid item xs={4} sm={2}>
              <TextField
                fullWidth
                type="number"
                placeholder="3"
                inputProps={{ min: 0, style: { fontSize: 16 } }}
                value={checkedOp?.experience_year ?? ""}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val.length <= 3) handleYearChange(id, e.target.value);
                }}
                disabled={!isChecked}
              />
            </Grid>

            <Grid item xs={4} sm={1}>
              <Typography sx={{ fontSize: 16 }}>年以上</Typography>
            </Grid>
          </Grid>
        );
      })}
    </Box>
  );
};

export default OperationExperience;
